import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

// Lets the signed-in admin open the manufacturer portal as a chosen manufacturer.
export function ActAsPicker({ onPick }) {
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/admin/manufacturers").then((r) => setList(r.data)).catch(() => {});
  }, []);
  const pick = (id) => {
    localStorage.setItem("ao_act_as", id);
    onPick(id);
  };
  return (
    <div className="min-h-screen grid place-items-center px-6" data-testid="act-as-picker">
      <div className="w-full max-w-md rounded-sm border border-[#D4AF37]/25 bg-[#14110E] p-8">
        <p className="text-[11px] uppercase tracking-[0.5em] text-[#D4AF37]">Admin</p>
        <h1 className="font-display text-3xl mt-3">Open manufacturer portal as…</h1>
        <div className="mt-6 space-y-2">
          {list.length === 0 && <p className="text-sm text-[#6E6558]">No manufacturers yet. Create one in the admin portal first.</p>}
          {list.map((m) => (
            <button key={m.id} onClick={() => pick(m.id)} className="w-full text-left rounded-sm border border-[#D4AF37]/15 p-4 hover:bg-[#1D1915]" data-testid={`act-as-${m.id}`}>
              <p className="text-sm">{m.name} {m.region && <span className="font-serif-it text-[#A89F91]">· {m.region}</span>}</p>
              <p className="text-xs text-[#6E6558]">{m.email}</p>
            </button>
          ))}
        </div>
        <Link to="/admin" className="block mt-6 text-xs uppercase tracking-[0.2em] text-[#A89F91] hover:text-[#F3E5AB]" data-testid="act-as-back-admin">← Back to admin</Link>
      </div>
    </div>
  );
}
